$(document).ready( function(){
	if ( $('.js-sorting-mobile-select').length ){
		$('.js-sorting-mobile-select').change( function() {
			var url = $(this).val(),
				sortingElem = $('option:selected', this).attr('data-sorting');
			window.location = url;
			return false;
		});
	}
});